import {
  RequestIndiceInterface,
  ResponseGetLibroIndicesInterface,
} from "interfaces/Indices/indice";
import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { axiosBaseQuery } from "config/axiosBaseQuery";

const baseUrl = process.env.REACT_APP_BACKEND_URL || "http://localhost/api/";

export const apiLibroIndice = createApi({
  reducerPath: "libroIndiceApi",
  baseQuery: axiosBaseQuery({
    baseUrl,
  }),
  endpoints(build) {
    return {
      getIndices: build.mutation<ResponseGetLibroIndicesInterface, unknown>({
        query: ({ ...args }: RequestIndiceInterface) => ({
          url: `indices`,
          method: "POST",
          data: { ...args },
        }),
      }),
    };
  },
});

export const { useGetIndicesMutation } = apiLibroIndice;
